export const gamesPage = {
    'games.page.title': '游戏',
}
